
export function init() {

	const $read_more = $(".read_more");
	const open_class = "is_open";

	$read_more.each(function () {
		let $wrap = $("<div class='read_more__wrap' />");
		let $wrappble = $(this).children().not(":first-child");
		if ($wrappble.length) {
			$wrappble.wrapAll($wrap);
			// read more button
			let $read_more_button = $("<a href='#' class='read_more__button'>Read More</a>")
			$read_more_button.on("click", function (e) {
				e.preventDefault();
				$(this).prev().addClass(open_class);
				$(this).remove();
				$read_more[0].scrollIntoView();
			});
			$(this).append($read_more_button);
		}
	});
}
